import React, { useState } from "react";
import { Box, IconButton, TextField } from "@mui/material";
import { InputContainer } from "../style";
import { QuerySendIcon } from "../../../Common/assets/Icons";
import { useAppDispatch, useAppSelector } from "../../../../Redux/hooks";
import { sendAiQuery } from "../../../../Redux/actions/aiSearchAction";

const AiSearchInput = () => {
  const [textValue, setTextValue] = useState("");
  const dispatch = useAppDispatch();
  const buttonLoader = useAppSelector((state) => state.aiSearch.resultLoader);

  const handleTextChange = (event: any) => {
    setTextValue(event.target.value);
  };

  const handleSend = () => {
    dispatch(sendAiQuery(textValue));
    setTextValue("");
  };

  const handleKeyDown = (event: any) => {
    if (!buttonLoader && textValue) {
      if (event.key === "Enter") {
        dispatch(sendAiQuery(textValue));
        setTextValue("");
      }
    }
  };

  return (
    <Box sx={InputContainer}>
      <TextField
        onChange={handleTextChange}
        onKeyDown={handleKeyDown}
        autoFocus
        placeholder="Type here..."
        value={textValue}
        sx={{ width: "100%" }}
        InputProps={{
          endAdornment: (
            <IconButton
              onClick={handleSend}
              disabled={buttonLoader || !textValue}
            >
              <QuerySendIcon />
            </IconButton>
          ),
        }}
      />
    </Box>
  );
};

export default React.memo(AiSearchInput);
